import React, { forwardRef } from 'react';
import { node } from 'prop-types';
import { useFormState } from 'react-final-form';
import FormErrorsAlert from './FormErrorsAlert';
import Collapse from '../FormFields/Collapse';
import './FormErrors.less';
const FormErrors = forwardRef((props, refForErrorAlert) => {
    const { fieldErrorMessage } = props;
    const formState = useFormState({
        subscription: { submitFailed: true, valid: true },
    });
    const { submitFailed, valid } = formState;
    const isErrorAlertShown = submitFailed && !valid;
    return (React.createElement("div", { className: 'kal-form-errors', ref: refForErrorAlert },
        React.createElement(Collapse, { isExpanded: isErrorAlertShown }, isErrorAlertShown && React.createElement(FormErrorsAlert, { fieldErrorMessage: fieldErrorMessage }))));
});
FormErrors.propTypes = {
    fieldErrorMessage: node,
};
FormErrors.displayName = 'FormErrors';
export default FormErrors;
//# sourceMappingURL=FormErrors.js.map